import { useMemo } from 'react';
import { useSubscriptions, useSubscriptionsConstruction, useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { SUBSCRIPTION_STATUS, SUBSCRIPTION_TYPES } from '../helpers/const';
import { isPaidSubscription, shouldShowExpiredMessage } from '../helpers/utils';
const useUserSubscriptions = () => {
  const {
    value: useConstructionAPI,
    loading: loadingUseConstructionAPI
  } = useAlloyFeatureFlag('switch-get-user-subscriptions-api-call');
  const {
    data: userSubscriptionsData,
    error: userSubscriptionsError
  } = useSubscriptions(!loadingUseConstructionAPI && !useConstructionAPI);
  const {
    data: userSubscriptionsConstructionData,
    error: userSubscriptionsConstructionError
  } = useSubscriptionsConstruction(!loadingUseConstructionAPI && useConstructionAPI);
  const userTrialSubscriptions = useMemo(() => {
    if (userSubscriptionsError) return null;
    if (!userSubscriptionsData) return null;
    return userSubscriptionsData.filter(subscription => subscription.type === SUBSCRIPTION_TYPES.TRIAL && !isPaidSubscription(subscription, userSubscriptionsData)).sort((a, b) => a.offeringCategoryRanking - b.offeringCategoryRanking);
  }, [userSubscriptionsData, userSubscriptionsError]);
  const userTrialSubscriptionsV2 = useMemo(() => {
    if (userSubscriptionsConstructionError) return null;
    if (!userSubscriptionsConstructionData) return null;
    return userSubscriptionsConstructionData.filter(subscription => subscription.type === SUBSCRIPTION_TYPES.TRIAL && !isPaidSubscription(subscription, userSubscriptionsConstructionData));
  }, [userSubscriptionsConstructionData, userSubscriptionsConstructionError]);
  const showBanner = useMemo(() => {
    if (loadingUseConstructionAPI) return null;
    if (userSubscriptionsError || userSubscriptionsConstructionError) return null;
    if (!useConstructionAPI && (!userTrialSubscriptions || (userTrialSubscriptions === null || userTrialSubscriptions === void 0 ? void 0 : userTrialSubscriptions.length) === 0)) return null;
    if (useConstructionAPI && (!userTrialSubscriptionsV2 || (userTrialSubscriptionsV2 === null || userTrialSubscriptionsV2 === void 0 ? void 0 : userTrialSubscriptionsV2.length) === 0)) return null;
    const subscriptionsToUse = useConstructionAPI ? userTrialSubscriptionsV2 || [] : userTrialSubscriptions || [];
    const noActiveTrials = subscriptionsToUse.every(subscription => subscription.status === SUBSCRIPTION_STATUS.EXPIRED);
    if (noActiveTrials) {
      return shouldShowExpiredMessage(subscriptionsToUse);
    }
    return true;
  }, [userSubscriptionsError, userTrialSubscriptions, userTrialSubscriptionsV2, userSubscriptionsConstructionError, useConstructionAPI, loadingUseConstructionAPI]);
  return {
    userTrialSubscriptions: useConstructionAPI ? userTrialSubscriptionsV2 : userTrialSubscriptions,
    userSubscriptionsError: useConstructionAPI ? userSubscriptionsConstructionError : userSubscriptionsError,
    showBanner
  };
};
export default useUserSubscriptions;
//# sourceMappingURL=useUserSubscriptions.js.map